import {Injectable} from '@angular/core';
import {ClassroomAction} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';
import {RemoteUserAdditionalInfoStateModel, RemoteUsersInfoState} from '@app/state/remote-users.state';

@Injectable({
  providedIn: 'root'
})
export class SharedHandlersService {
  private remoteUsers: { [key: number]: RemoteUserAdditionalInfoStateModel } = {};

  constructor(
    private store: Store
  ) {
    this.listenStoreChanges();
  }

  public listenStoreChanges() {
    this.store.select(RemoteUsersInfoState.getUsersInfo).subscribe(usersInfoById => {
      this.remoteUsers = usersInfoById;
    });

  }
}
